import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { firstStepConfig, LeadRegistrationStepsEnum } from './constant'

const domain = createDomain('features.leadRegistration.step')

export const Gate = createGate()

export const goToConfirmCodeStep = domain.createEvent()
export const goToErrorStep = domain.createEvent()
export const goToFirstStep = domain.createEvent()

sample({
  clock: Gate.close,
  target: goToFirstStep,
})

export const $currentStep = domain
  .createStore<string>(firstStepConfig)
  .on(goToConfirmCodeStep, () => LeadRegistrationStepsEnum.CONFIRM_CODE_STEP)
  .on(goToErrorStep, () => LeadRegistrationStepsEnum.ERROR_STEP)
  .on(goToFirstStep, () => firstStepConfig)

export const $currentStepFlags = $currentStep.map((step) => ({
  isFormStep: step === LeadRegistrationStepsEnum.FORM_STEP,
  isConfirmCodeStep: step === LeadRegistrationStepsEnum.CONFIRM_CODE_STEP,
  isErrorStep: step === LeadRegistrationStepsEnum.ERROR_STEP,
}))
